import root from 'window-or-global';

if (root && root.__webpack_asset_path) {
    //eslint-disable-line
    __webpack_public_path__ = root['__webpack_asset_path']; //eslint-disable-line
}

import React from 'react';
import ReactDOM from 'react-dom';
import pako from 'pako';
import App from './App';
import ScrollOnUpdate from './routes/ScrollOnUpdate';
import RefreshOnSessionChange from 'epic-diesel-common/src/components/session/RefreshOnSessionChange';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {fromJS} from 'immutable';
import {configureStore} from './configureStore';
import {configureTracking} from './utils/TrackingUtils';
import {setLocale} from 'epic-common/src/locale';
import {LocalizationContext} from 'epic-localization/src/context/LocalizationContext';
import './thirdPartyStyles';
// import './overrides/axios.override';

/**
 * The react app will look for a DOM element with this ID and insert itself there.
 */
const reactDomEle = root && root.document && root.document.getElementById('affiliateWrapper');

let initialState = fromJS({});
let epicState = root.__epic_client_state;

if (epicState && typeof epicState === 'string') {
    setLocale(root.__locale);
    epicState = JSON.parse(pako.inflate(epicState.split(','), {to: 'string'}));
    initialState = fromJS(epicState);
}

const {
    user: {isLoggedIn}
} = epicState;

const store = configureStore(initialState);
configureTracking({initialState});

const localization = epicState.localization || {};
const i18nContext = {
    messages: localization.messageProperties,
    supportedLocales: localization.supportedLocales,
    locale: localization.locale
};

export type RootState = ReturnType<typeof store.getState>;

ReactDOM.hydrate(
    <BrowserRouter>
        <RefreshOnSessionChange isLoggedIn={isLoggedIn}>
            <Provider store={store}>
                <ScrollOnUpdate>
                    <LocalizationContext.Provider value={i18nContext}>
                        <App />
                    </LocalizationContext.Provider>
                </ScrollOnUpdate>
            </Provider>
        </RefreshOnSessionChange>
    </BrowserRouter>,
    reactDomEle
);
